import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { style: {"animation":"Circular-_-rotate 2s linear infinite","height":"50px","transform-origin":"center center","width":"50px"} }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    "stroke-width": "5",
    "stroke-miterlimit": "10",
    stroke: "currentColor",
    style: {"stroke-dasharray":"1,200","stroke-dashoffset":"0","animation":"Circular-_-dash 1.5s ease-in-out infinite","stroke-linecap":"round"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }